import { useEffect, useState } from "react";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Portfolio } from "./components/Portfolio";
import { Cost } from "./components/Cost";
import { Inquiry } from "./components/Inquiry";
import { Footer } from "./components/Footer";

export function App() {
  const [recaptchaSiteKey, setRecaptchaSiteKey] = useState<string>("");

  // Pull the public reCAPTCHA site key from the server and inject the script tag.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch("/api/config");
        const cfg = (await res.json()) as { recaptchaSiteKey: string };
        if (cancelled) return;
        setRecaptchaSiteKey(cfg.recaptchaSiteKey);
        if (cfg.recaptchaSiteKey) {
          const existing = document.querySelector('script[data-recaptcha="true"]');
          if (!existing) {
            const s = document.createElement("script");
            s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(
              cfg.recaptchaSiteKey
            )}`;
            s.async = true;
            s.defer = true;
            s.dataset.recaptcha = "true";
            document.head.appendChild(s);
          }
        }
      } catch (e) {
        console.error("[app] failed to load config:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Services />
        <Portfolio />
        <Cost />
        <Inquiry recaptchaSiteKey={recaptchaSiteKey} />
      </main>
      <Footer />
    </>
  );
}
